import script from "./ViewVModel.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewVModel.vue?vue&type=script&setup=true&lang=js"

import "./ViewVModel.vue?vue&type=style&index=0&id=bbe02230&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbe02230"]])

export default __exports__